var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-container"},[_c('img',{staticClass:"popularBgImg",attrs:{"src":require("../assets/Home/popularBgImg.png")}}),_c('div',{staticClass:"detailsBox"},[_c('div',{staticClass:"title"},[_vm._v(" 关于平台 ")]),_c('div',{staticClass:"msgContent",domProps:{"innerHTML":_vm._s(_vm.aboutContent)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }